import { render, staticRenderFns } from "./BannerSliderItem.vue?vue&type=template&id=62edff9b&scoped=true"
import script from "./BannerSliderItem.vue?vue&type=script&lang=js"
export * from "./BannerSliderItem.vue?vue&type=script&lang=js"
import style0 from "./BannerSliderItem.vue?vue&type=style&index=0&id=62edff9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62edff9b",
  null
  
)

export default component.exports